import React, { useState, useEffect } from 'react';
import { ArrowRight } from 'lucide-react';

const BlogPage = ({ onSelectPost }) => {
    const [posts, setPosts] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        fetch('/content/blog/posts.json')
            .then(res => res.json())
            .then(data => {
                // Sort posts by date, newest first
                data.sort((a, b) => new Date(b.date) - new Date(a.date));
                setPosts(data);
                setLoading(false);
            })
            .catch(err => {
                console.error("Failed to load blog posts:", err);
                setLoading(false);
            });
    }, []);

    if (loading) {
        return <div className="text-center">Loading posts...</div>;
    }

    return (
        <div>
            <div className="text-center mb-8">
                <h1 className="text-2xl md:text-4xl font-bold text-gray-900 dark:text-cyan-400 mb-2">The SABR Calculator Blog</h1>
                <p className="text-gray-600 dark:text-gray-400">Insights and updates on radiation oncology, CPD, and clinical practice.</p>
            </div>
            <div className="space-y-8 max-w-3xl mx-auto">
                {posts.map(post => (
                    <div key={post.slug} className="p-6 bg-gray-50 dark:bg-gray-800/50 rounded-lg border dark:border-gray-700">
                        <h2 className="text-2xl font-bold text-blue-800 dark:text-blue-400">{post.title}</h2>
                        <p className="text-sm text-gray-500 dark:text-gray-500 mt-1">By {post.author} on {new Date(post.date).toLocaleDateString()}</p>
                        <p className="text-gray-700 dark:text-gray-300 mt-3">{post.summary}</p>
                        <button onClick={() => onSelectPost(post.slug)} className="mt-4 inline-flex items-center text-sm font-semibold text-blue-600 hover:text-blue-500">
                            Read More <ArrowRight size={16} className="ml-1" />
                        </button>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default BlogPage;